import { render, staticRenderFns } from "./events-filter.vue?vue&type=template&id=663efd63&scoped=true&"
import script from "./events-filter.vue?vue&type=script&lang=js&"
export * from "./events-filter.vue?vue&type=script&lang=js&"
import style0 from "./events-filter.vue?vue&type=style&index=0&id=663efd63&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "663efd63",
  null
  
)

export default component.exports